import ATM from './Atm.js';

function Withdraw(){
  return (
    <ATM isDeposit={ false }/>
  )
};

export default Withdraw;